﻿export enum Filter {
    TextFilter = 1,
    NumberFilter = 2,
    DateFilter = 3,
    DateTimeFilter = 4,
    BoolFilter = 5,
    None = 6
};